import React from 'react'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import faCalendar from '@fortawesome/fontawesome-free-solid/faCalendarPlus'
import faLanguage from '@fortawesome/fontawesome-free-solid/faLanguage'
import '../../styles/InformationItem.css'

const Icon = ({ icon, color }) => {
  switch (icon) {
    case 'calendar':
      return (
        <FontAwesomeIcon
          className={'informationItemIcon'}
          icon={faCalendar}
          color={color}
        />
      )
    case 'language':
      return (
        <FontAwesomeIcon
          className={'informationItemIcon'}
          icon={faLanguage}
          color={color}
        />
      )
    case '1':
      return <p className={'informationItemIcon'}>1</p>
    case '2':
      return <p className={'informationItemIcon'}>2</p>
    case '3':
      return <p className={'informationItemIcon'}>3</p>
    default:
  }
}

const InformationItem = ({
  icon,
  header,
  text,
  position = 'left',
  color = '#3b424d',
  iconName = 'calendar',
  marginTop = 0
}) => {
  if (position === 'left') {
    return (
      <div style={{ marginTop }} className={'informationItemLeftContainer'}>
        <div className={'informationItemLeftInnerContainer'}>
          <h2
            className={'informationItemHeader'}
            style={{ textAlign: 'right' }}
          >
            {header}
          </h2>
          <p className={'informationItemText'} style={{ textAlign: 'right' }}>
            {text}
          </p>
        </div>
        <div
          style={{ borderColor: color }}
          className={'informationItemImageContainer'}
        >
          <Icon icon={iconName} color={color} />
        </div>
      </div>
    )
  }
  return (
    <div style={{ marginTop }} className={'informationItemRightContainer'}>
      <div
        style={{ borderColor: color }}
        className={'informationItemImageContainer'}
      >
        <Icon icon={iconName} color={color} />
      </div>
      <div className={'informationItemRightInnerContainer'}>
        <p className={'informationItemHeader'}>{header}</p>
        <p className={'informationItemText'}>{text}</p>
      </div>
    </div>
  )
}

export { InformationItem }



// WEBPACK FOOTER //
// ./src/components/common/InformationItem.js